module.exports = __webpack_public_path__ + "img/research-speed.3312ae5b.png";